/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import {
  Assignment,
  Build,
  PermContactCalendar,
  VerifiedUser,
  Person,
  AccountBalance,
  Settings
} from "@material-ui/icons/";
// core components
import Navbar from "components/Navbars/Navbar.js";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import FixedPlugin from "components/FixedPlugin/FixedPlugin.js";
import styles from "assets/jss/material-dashboard-react/layouts/adminStyle.js";
import {
  DateRange,
  Bookmarks,
  ExitToApp,
  CalendarToday
} from "@material-ui/icons/";

import bgImage from "assets/img/sidebar-2.jpg";
import logo from "assets/img/logo2.png";

import Goto from "views/Refund/Goto";

import axios from "axios";
import Request from "views/Refund/Request";
import FinanceBudgetView from "views/Finance/budget";
import BudgetReportView from "views/Finance/budget/BudgetReportView";
import FinanceMasterDataView from "views/Finance/budget/FinanceMasterDataView";
import SalaryView from "views/Finance/Salary";
import SalaryDetailedReport from "views/Finance/budget/SalaryDetailedReport";
import MySalarySlip from "views/Finance/Salary/MySalarySlip";
import BeamPaymentReportView from "views/Finance/Beam/BeamPaymentReportView";
import LogoutPage from "views/UserProfile/LogoutPage.js";
import MonetizationOn from "@material-ui/icons/MonetizationOn";
import Description from "@material-ui/icons/Description";
import Payment from "@material-ui/icons/Payment";
import Receipt from "@material-ui/icons/Receipt";
import Business from "@material-ui/icons/Business";
import Category from "@material-ui/icons/Category";
import FormatListBulleted from "@material-ui/icons/FormatListBulleted";
import AttachMoney from "@material-ui/icons/AttachMoney";
import Layers from "@material-ui/icons/Layers";
import PlaylistAddCheck from "@material-ui/icons/PlaylistAddCheck";
import SubdirectoryArrowRight from "@material-ui/icons/SubdirectoryArrowRight";
import Domain from "@material-ui/icons/Domain";
import TableChart from "@material-ui/icons/TableChart";
import Assessment from "@material-ui/icons/Assessment";
let ps;

const useStyles = makeStyles(styles);

export default function Leave({ ...rest }) {
  // styles
  const classes = useStyles();
  // ref to help us initialize PerfectScrollbar on windows devices
  const mainPanel = React.createRef();
  // states and functions
  const [image, setImage] = React.useState(bgImage);
  const [color, setColor] = React.useState("blue");
  const [fixedClasses, setFixedClasses] = React.useState("dropdown show");
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [isHR, setIsHR] = useState(false);

  const currentUser = (() => {
    try {
      const u = localStorage.getItem("currentUser");
      return u ? JSON.parse(u) : null;
    } catch {
      return null;
    }
  })();

  const userDepts = (() => {
    if (!currentUser) return [];
    return Array.isArray(currentUser.userDepartment)
      ? currentUser.userDepartment
      : Array.isArray(currentUser.userView?.userDepartment)
      ? currentUser.userView.userDepartment
      : [];
  })();

  const isAdmin =
    currentUser?.roles?.includes("Admin") ||
    currentUser?.userName === "madarakung" ||
    userDepts.some(u => Number(u.departmentKey) === 108);

  // 1. ระบบ Salary: isFinance ใช้ depKey เฉพาะ 157 เท่านั้น
  const isFinance = (() => {
    if (!currentUser) return false;
    const hasSalaryDep = userDepts.some(u => {
      const depKey = Number(u.departmentKey);
      return depKey === 157;
    });
    return hasSalaryDep || isAdmin;
  })();

  // 2. ระบบ Budget: IsFinanceAccount ใช้ depKey 102, 135, 157
  const isFinanceAccount = (() => {
    if (!currentUser) return false;
    const hasBudgetDep = userDepts.some(u => {
      const depKey = Number(u.departmentKey);
      return depKey === 102 || depKey === 135 || depKey === 157;
    });
    return hasBudgetDep || isAdmin;
  })();

  // 3. ระบบรายงานงบประมาณ: กำหนดสิทธิเข้าใช้งานได้จาก isFinance, isFinanceAccount และ DepartmentKey 110 ด้วย
  const canAccessBudgetReport = (() => {
    if (!currentUser) return false;
    const hasReportDep = userDepts.some(u => Number(u.departmentKey) === 110);
    return isFinance || isFinanceAccount || hasReportDep || isAdmin;
  })();

  const routes = [
    ...(isFinance
      ? [
          {
            name: "ระบบจัดการเงินเดือน",
            icon: MonetizationOn,
            component: SalaryView,
            layout: "/finance",
            path: "/salary"
          },
          {
            name: "รายงานเงินเดือนโดยละเอียด",
            icon: TableChart,
            component: SalaryDetailedReport,
            layout: "/finance",
            path: "/salary-detailed-report"
          }
        ]
      : []),
    {
      name: "สลิปเงินเดือน",
      icon: Description,
      component: MySalarySlip,
      layout: "/finance",
      path: "/slip"
    },
    ...(isFinanceAccount
      ? [
          {
            name: "ระบบกันเงิน",
            icon: AccountBalance,
            component: FinanceBudgetView,
            layout: "/finance",
            path: "/budget"
          }
        ]
      : []),
    ...(canAccessBudgetReport
      ? [
          {
            name: "รายงานงบประมาณ",
            icon: Assessment,
            component: BudgetReportView,
            layout: "/finance",
            path: "/budget-report"
          }
        ]
      : []),
    ...(isFinanceAccount
      ? [
          {
            collapse: true,
            name: "จัดการข้อมูลระบบกันเงิน",
            icon: Settings,
            state: "masterDataCollapse",
            layout: "/finance",
            path: "/master-data",
            views: [
              {
                name: "โครงการ",
                icon: Assignment,
                layout: "/finance",
                path: "/master-data/project",
                subTab: "project",
                tab: 0,
                component: FinanceMasterDataView
              },
              {
                name: "บริษัท / คู่ค้า",
                icon: Business,
                layout: "/finance",
                path: "/master-data/company",
                subTab: "company",
                tab: 1,
                component: FinanceMasterDataView
              },
              {
                name: "หมวดจัดซื้อ",
                icon: Category,
                layout: "/finance",
                path: "/master-data/category",
                subTab: "category",
                tab: 2,
                component: FinanceMasterDataView
              },
              {
                name: "หมวดย่อย",
                icon: FormatListBulleted,
                layout: "/finance",
                path: "/master-data/subcategory",
                subTab: "subcategory",
                tab: 3,
                component: FinanceMasterDataView
              },
              {
                name: "ประเภทงบประมาณ",
                icon: AccountBalance,
                layout: "/finance",
                path: "/master-data/budgettype",
                subTab: "budgettype",
                tab: 4,
                component: FinanceMasterDataView
              },
              {
                name: "ข้อมูลงบประมาณ",
                icon: MonetizationOn,
                layout: "/finance",
                path: "/master-data/budget-info",
                subTab: "budget-info",
                tab: 5,
                component: FinanceMasterDataView
              },
              {
                name: "แหล่งของเงิน",
                icon: AttachMoney,
                layout: "/finance",
                path: "/master-data/sourcemoney",
                subTab: "sourcemoney",
                tab: 6,
                component: FinanceMasterDataView
              },
              {
                name: "ผลผลิต",
                icon: Layers,
                layout: "/finance",
                path: "/master-data/output",
                subTab: "output",
                tab: 7,
                component: FinanceMasterDataView
              },
              {
                name: "กิจกรรมหลัก",
                icon: PlaylistAddCheck,
                layout: "/finance",
                path: "/master-data/activity",
                subTab: "activity",
                tab: 8,
                component: FinanceMasterDataView
              },
              {
                name: "กิจกรรมย่อย",
                icon: SubdirectoryArrowRight,
                layout: "/finance",
                path: "/master-data/subactivity",
                subTab: "subactivity",
                tab: 9,
                component: FinanceMasterDataView
              },
              {
                name: "ตามบันทึก",
                icon: Description,
                layout: "/finance",
                path: "/master-data/note",
                subTab: "note",
                tab: 10,
                component: FinanceMasterDataView
              },
              {
                name: "หน่วยงานที่ขอ",
                icon: Domain,
                layout: "/finance",
                path: "/master-data/department",
                subTab: "department",
                tab: 11,
                component: FinanceMasterDataView
              }
            ]
          }
        ]
      : []),
    ...(isFinance
      ? [
          {
            collapse: true,
            name: "Beam",
            icon: Payment,
            state: "beamCollapse",
            layout: "/finance",
            path: "/beam",
            views: [
              {
                name: "รายงานการชำระเงิน",
                icon: Receipt,
                layout: "/finance",
                path: "/beam/payment-report",
                component: BeamPaymentReportView
              }
            ]
          }
        ]
      : []),
    {
      name: "แบบคำขอคืนเงิน",
      icon: Assignment,
      component: Request,
      layout: "/refund",
      path: "/request"
    }
  ];

  const defaultFinanceRedirect = isFinance
    ? "/finance/salary"
    : isFinanceAccount
    ? "/finance/budget"
    : canAccessBudgetReport
    ? "/finance/budget-report"
    : "/finance/slip";

  const switchRoutes = (
    <Switch>
      <Route
        path="/finance/salary"
        render={props =>
          isFinance ? (
            <SalaryView {...props} />
          ) : (
            <Redirect to="/finance/slip" />
          )
        }
      />
       <Route
        path="/finance/salary-detailed-report"
        render={props =>
          isFinance ? (
            <SalaryDetailedReport {...props} />
          ) : (
            <Redirect to="/finance/slip" />
          )
        }
      />
      
      <Route path="/finance/slip" component={MySalarySlip} />
      <Route
        path="/finance/budget"
        render={props =>
          isFinanceAccount ? (
            <FinanceBudgetView {...props} />
          ) : (
            <Redirect to="/finance/slip" />
          )
        }
      />
      <Route
        path="/finance/budget-report"
        render={props =>
          canAccessBudgetReport ? (
            <BudgetReportView {...props} />
          ) : (
            <Redirect to="/finance/slip" />
          )
        }
      />
      <Redirect from="/finance/budget/report" to="/finance/budget-report" />
      <Route
        path="/finance/master-data/:subTab"
        render={props =>
          isFinanceAccount ? (
            <FinanceMasterDataView {...props} />
          ) : (
            <Redirect to="/finance/slip" />
          )
        }
      />
      <Route
        exact
        path="/finance/master-data"
        render={() =>
          isFinanceAccount ? (
            <Redirect to="/finance/master-data/project" />
          ) : (
            <Redirect to="/finance/slip" />
          )
        }
      />
      <Route
        path="/finance/beam/payment-report"
        render={props =>
          isFinance ? (
            <BeamPaymentReportView {...props} />
          ) : (
            <Redirect to="/finance/slip" />
          )
        }
      />
      <Redirect
        from="/finance/beam"
        to={isFinance ? "/finance/beam/payment-report" : "/finance/slip"}
      />
      <Route path="/refund/request" component={Request} />
      <Route path="/refund/id/:RefundRequestID" component={Goto} />
      <Redirect from="/refund" to="/refund/request" />
      <Redirect from="/finance" to={defaultFinanceRedirect} />
    </Switch>
  );

  const handleImageClick = image => {
    setImage(image);
  };
  const handleColorClick = color => {
    setColor(color);
  };
  const handleFixedClick = () => {
    if (fixedClasses === "dropdown") {
      setFixedClasses("dropdown show");
    } else {
      setFixedClasses("dropdown");
    }
  };
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const getRoute = () => {
    return window.location.pathname !== "/admin/maps";
  };
  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };
  // initialize and destroy the PerfectScrollbar plugin
  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: false
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", resizeFunction);

    axios({
      method: "post",
      url: "/api/v1/currentdate"
    }).then(
      result => {
        var currentUser = JSON.parse(localStorage.getItem("currentUser"));
        const _isHR =
          currentUser.userDepartment.filter(
            u =>
              u.departmentKey == 105 ||
              u.departmentKey == 108 ||
              (u.departmentKey == 143 && u.userLevelKey == 3)
          ).length > 0;
        setIsHR(_isHR);
      },
      error => {
        console.log(error);
      }
    );
    // Specify how to clean up after this effect:
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
      window.removeEventListener("resize", resizeFunction);
    };
  }, [mainPanel]);
  return (
    <div className={classes.wrapper}>
      <Sidebar
        routes={routes}
        logoText={"ระบบการเงิน"}
        logo={logo}
        image={image}
        handleDrawerToggle={handleDrawerToggle}
        open={mobileOpen}
        color={color}
        {...rest}
      />
      <div className={classes.mainPanel} ref={mainPanel}>
        <Navbar
          routes={routes}
          handleDrawerToggle={handleDrawerToggle}
          {...rest}
        />
        {/* On the /maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
        {getRoute() ? (
          <div className={classes.content}>
            <div className={classes.container}>{switchRoutes}</div>
          </div>
        ) : (
          <div className={classes.map}>{switchRoutes}</div>
        )}
        {getRoute() ? <Footer /> : null}
        {/* <FixedPlugin
          handleImageClick={handleImageClick}
          handleColorClick={handleColorClick}
          bgColor={color}
          bgImage={image}
          handleFixedClick={handleFixedClick}
          fixedClasses={fixedClasses}
        /> */}
      </div>
    </div>
  );
}
